import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {VisibilityOff, Visibility} from '@mui/icons-material'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import InputAdornment from '@mui/material/InputAdornment'
import {injectIntl} from 'react-intl'
import Header from 'containers/Header/Desktop'
import Sidebar from 'containers/Sidebar'
import Container from 'components/Container'
import UserImage from 'components/UserImage'
import {setUserData, changePassword, getCallUrl, setCallUrl} from 'modules/login/actions'
import {isMobile} from 'utils/utils'

const Row = styled.div`
    display: flex;
`

const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`

const Name = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
    font-weight: 700;
    font-size: 20px;
    overflow: hidden;

    > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const Block = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
    padding: 20px;
    width: 50%;
    justify-content: space-between;

    :first-child {
        margin-right: 20px;
    }
`

const Title = styled.div`
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 30px;
`

const Icon = styled(IconButton)`
	&:hover {
		background-color: initial;
	}
`

const Field = styled(TextField)`
	margin-bottom: 30px;
	width: 100%;
`

class Profile extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            logo: '',
            username: '',
            password: '',
            repeat: '',
            url: null,
            showPass: false,
            showRepeate: false
        }
    }

    componentDidMount() {
        const mobile = isMobile()

        if (mobile) {
            this.props.navigate('/', {replace: true})
        } else {
            this.props.getCallUrl()
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleDownload = (e) => {
        const file = e.currentTarget.files[0]

        if (file) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => this.setState({
                logo: reader.result
            })
            reader.onerror = (error) => alert(error)
        }
    }

    handleUpdate = () => {
        if (this.state.url !== null && this.state.url !== this.props.url) {
            this.props.setCallUrl(this.state.url)
        }

        if (this.state.logo || this.state.username) {
            const data = {}
            if (this.state.logo) {
                data.image = this.state.logo
            }

            if (this.state.username) {
                data.name = this.state.username
            }

            this.props.setUserData({...data})
            this.setState({
                logo: ''
            })
        }
    }

    handleClear = (e) => {
        e.stopPropagation()
        this.input.value = ''
    }

    handleClick = () => {
        this.input.click()
    }

    handleToggle = (e) => {
        const name = e.currentTarget.name
        this.setState(state => ({ [name]: !state[name] }))
    }

    handleChangePass = () => {
        this.props.changePassword(this.state.password)
        this.setState({
            password: '',
            repeat: ''
        })
    }

    render() {
        const {intl, image, username, url} = this.props

        return (
            <React.Fragment>
                <Header padding={global.SIDE_BAR_NORMAL_WIDTH}>
                    <Name>
                        <div>{intl.formatMessage({id: "profile.profile_editing"})}</div>
                    </Name>
                </Header>
                <Sidebar logo={this.props.logo}>

                </Sidebar>
                <Container marginTop={117} style={{padding: '20px 20px 20px 276px', marginLeft: 0, height: 'initial'}}>
                    <Row>
                        <Block>
                            <Title>{intl.formatMessage({id: "profile.my_profile"})}</Title>
                            <UserImage margin={'0 0 20px 0'}
                                type={this.state.logo ? 1 : image.type}
                                value={this.state.logo ? this.state.logo : image.value}
                                size='large'
                                onClick={this.handleClick}
                            />
                            <Input type='file'
                                onChange={this.handleDownload} ref={el => this.input = el}
                                accept="image/jpeg, image/png, image/gif"
                            />
                            <Field variant="standard"
                                onChange={this.handleChange}
                                label={intl.formatMessage({id: "profile.username"})}
                                defaultValue={username}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={{
                                    name: 'username'
                                }}
                            />
                            {url !== null &&
                                <Field variant="standard"
                                    onChange={this.handleChange}
                                    label={intl.formatMessage({id: "profile.quick_call_url"})}
                                    defaultValue={url}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{
                                        name: 'url'
                                    }}
                                />
                            }
                            <Button variant="contained"
                                color="primary"
                                onClick={this.handleUpdate}
                                disabled={(this.state.username === username ||
                                    this.state.username.replace(/\s/g, '') === '') &&
                                    (this.state.url === null || this.state.url === url) &&
                                    !this.state.logo}
                            >
                                {intl.formatMessage({id: "app.confirm_save"})}
                            </Button>
                        </Block>
                        <Block>
                            <Title>{intl.formatMessage({id: "profile.change_password"})}</Title>
                            <Field variant="standard"
                                value={this.state.password}
                                onChange={this.handleChange}
                                label={intl.formatMessage({id: "profile.enter_new_password"})}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={{
                                    name: 'password'
                                }}
                                type={this.state.showPass ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Icon
                                                name='showPass'
                                                onClick={this.handleToggle}
                                            >
                                                {this.state.showPass ? <Visibility /> : <VisibilityOff />}
                                            </Icon>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Field variant="standard"
                                value={this.state.repeat}
                                onChange={this.handleChange}
                                label={intl.formatMessage({id: "profile.repeat_password"})}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={{
                                    name: 'repeat'
                                }}
                                type={this.state.showRepeate ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Icon
                                                name='showRepeate'
                                                onClick={this.handleToggle}
                                            >
                                                {this.state.showRepeate ? <Visibility /> : <VisibilityOff />}
                                            </Icon>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button variant="contained"
                                color="primary"
                                onClick={this.handleChangePass}
                                disabled={this.state.password.replace(/\s/g, '') === '' ||
                                    this.state.repeat.replace(/\s/g, '') === '' ||
                                    this.state.password !== this.state.repeat}
                            >
                                {intl.formatMessage({id: "app.confirm_save"})}
                            </Button>
                        </Block>
                    </Row>
                </Container>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({applications, login}) => ({
    applications: applications.data,
    logo: applications.logo,
    current: applications.current,
    image: login.logo,
    username: login.username,
    url: login.url
})

export default connect(mapStateToProps, {
    setUserData,
    changePassword,
    getCallUrl,
    setCallUrl
})(injectIntl(Profile))
